"use strict";
var async = require("async");

module.exports = function(
  $uibModal,
  $state,
  $window,
  $scope,
  $http,
  $sce,
  dialog,
  toast,
  Container,
  Authentication,
) {

  var _this = this;
    this.Authentication = Authentication;
    this.tutorialsData = [
        { 
            id: "1",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/EX8HmfxYHog"),
            title: "Field de Voölks - Alcance General de la Plataforma",
            description: "Este video describe el alcance general de la plataformas Field, para toma de datos en campo desde dispositivos moviles. Field comprende dos modulos principales: una plataforma Web para generar formularios digitales y una app para utilizar dichos formularios, offline, en la toma de datos en campo."
        },
        { 
            id: "2",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/8Vb8cbtQjh8"),
            title: "Alcance de la plataforma",
            description: "En este video, se detalla el alcance de Field, una solución en la nube diseñada para reemplazar formularios y plantillas utilizados en trabajos de campo, como inspecciones, certificaciones y relevamientos. Field se basa en la creación rápida de formularios, configuración de reportes, gestión de tareas, integración con otros sistemas y visualización de datos a través de un Tablero de Control."
        },
        { 
            id: "3",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/SlUSblpFgL8"),
            title: "Módulos y Funciones",
            description: "En este video se recorre rápidamente cada uno de los módulos y funciones tanto en la web, donde se gestiona formularios, usuarios, etc. como en la app móvil."
        },

        { 
            id: "4",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/i0-801777OU"),
            title: "Ejemplos de Formularios",
            description: "Como se genera un formulario electrónico y digital con Field y como se ve en la app? En este video mostramos algunos ejemplos para resulte mas facil entender la relación entre la Web de Field y la app de Field."
        },
        { 
            id: "5",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/bXwgwQFpOB8"),
            title: "Gestión de Usuarios",
            description: "Como doy de alta usuarios en Field? Es posible tomar usuarios del active directory de mi compañía? En este video les mostramos como dar de Alta usuarios y asignarlos a equipos o darles privilegios para acceder a ciertas funcionalidades."
        },
        { 
            id: "6",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/oQKCXl1YnZY"),
            title: "Departamentos y Sitios",
            description: "Como se organizan los formularios y datos que se toman con Field? Es posible usar Field en mas de una empresa o región que pertenecen al mismo grupo económico. En este video les mostramos como gestionar Sitios, departamentos, y administradores asociados a estos sitios."
        },

        { 
            id: "7",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/CWzza8VTjss"),
            title: "Field Service App",
            description: "Como se cargan datos en los formularios? Se pueden cargar desde la Web? Existe algún emulador para cargar datos desde la computadora como si fuera desde el celular. En este video les contamos como funciona la App de Field Service de Voölks."
        },
        { 
            id: "8",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/7yxnBNLFTRM"),
            title: "Integraciones",
            description: "Es posible mostrar en la app de Field datos provenientes de planilla guardadas en la nube como Google Drive o servicios parecidos? Puedo integrar Field con otros sistemas y que funcione offline como si estuviera conectado a internet funcionando online. En este video te mostramos como se puede hacer eso y si te registras en Field lo vas a poder ver en accion."
        },
        { 
            id: "9",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/bZVIglTcICo"),
            title: "Configuración de Reportes",
            description: "Es posible generar reportes vistosos con Field en donde se destaquen fotos, mapas, grillas de datos, e incorporar el logo de la empresa? En este video les mostramos como configurar reportes en Field, incluyendo logos, pie de pagina, gráficos, mapas y fotos."
        },
        { 
            id: "10",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/7Uo4LTj3Hc8"),
            title: "Envío Automático de Mails",
            description: "Es posible automatizar el envío de mails desde Field, al momento en que suben los formularios? Puedo tener distintos destinatarios dependiendo de algún valor tomado desde el formulario? Es posible mostrar una lista de valores de correos, para que el operador elija uno o mas destinatarios? En este video veremos como se configuran todas estas opciones."
        },
        { 
            id: "11",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/wMOFPQ8kbz4"),
            title: "Validación de Reportes",
            description: "Es posible validar los reportes generados en Field antes de ser enviados a la gerencia? Es posible automatizar este proceso? En este video les mostramos como configurar el Validador de Reportes el cual ha demostrado ser sumamente util para Supervisores que quieren validar los datos de campo, antes de circularlos dentro de la empresa o con sus clientes."
        },
        { 
            id: "12",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/gE3cPPbk1Vw"),
            title: "Visualización de datos",
            description: "Como se pueden ver los datos en Field? Me los puedo llevar a otro sistema o bajar a una planilla Exel para analizarlos? Tiene Field la posibilidad de tratar los datos en un Tablero de Indicadores? En este video, te mostramos como se puede hacer todo esto muy fácilmente."
        },
        { 
            id: "13",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/SiQTvCWj4zU"),
            title: "Flujos de Trabajo con Tablero de Indicadores",
            description: "Este video muestra el proceso de creación y visualización de Flujos de Trabajo en Field. El video parte de un formulario ya creado en donde se agregan distintas instancias de validación. Continua con la visualización del Flujo de Trabajo desde dispositivos móviles y culmina con la creación de un Tablero de Indicadores."
        },
        { 
            id: "14",
            link: $sce.trustAsResourceUrl("https://www.youtube.com/embed/QwvlfGHu1fo"),
            title: "Flujos de Trabajo con Creación de Formulario",
            description: "Este video muestra el proceso de creación y visualización de Flujos de Trabajo en Field. El video parte desde la creación de un formulario en donde se agregan distintas instancias de validación propias de un flujo de Trabajo. Continua con la visualización del Flujo de Trabajo en tres dispositivos móviles en donde se vean claramente como llegan las notificaciones a medida que se van superando las distintas instancias del flujo."
        }
    ];

  this.showWizard = function() {
    $uibModal.open({
      animation: true,
      controller: [
        "$uibModalInstance",
        "$http",
        "$stateParams",
        "$state"
        , 'Authentication',
        function($uibModalInstance, $http, $stateParams, $state, Authentication) {
          this.Authentication = Authentication;
          $state.wizardData = {};
          $state.wizardData.department = null;
          $state.wizardData.members = [];
          $state.wizardData.teams = [];
          $state.wizardData.team = null;
          $state.wizardData.forms = [];
          $state.wizardData.form = null;
          $state.wizardData.uibModalInstance = $uibModalInstance;

          $state.go('dashboard.wizard.departments');

        }
      ],
      templateUrl: "dashboard-wizard/dashboardWizardModal.html",
      controllerAs: "modalWizard",
      size: "xlg",
      windowClass: "dialog",
      bindToController: true
    }).result.then(function() {
        console.log('dashboard.wizard result then')
        $state.go('dashboard.wizard');
    }, function() {
        console.log('dashboard.wizard dismissed');
        $state.go('dashboard.wizard');
    });
  };

};
